import {
    Standard as StandardDataField,
    Ringtyp as RingtypDataField,
} from "../Entity/Kennzeichnung/StandardDataFields";

const SettingsFromSpecies = (species=null) => {

    if (species.istVogel) {
        return {
            "ringtyp":  RingtypDataField(),
            "ringnummer": StandardDataField(),
        };
    }

    if (species.istSaeugetier) {
        return {
            "microchip":  StandardDataField(),
        };
    }

    if (species.istSchildkroete) {
        return {
            fotodokumentation: {},
        };
    }

    return {}

}
export default SettingsFromSpecies;